export const AJAX_ACTION_TYPES = {
	AJAX_START: 'AJAX_START',
	AJAX_END: 'AJAX_END'
};

export const ajaxStart = ajaxRequestId => {
	return {
		type: AJAX_ACTION_TYPES.AJAX_START,
		payload: { ajaxRequestId }
	};
};

export const ajaxEnd = ajaxRequestId => {
	return {
		type: AJAX_ACTION_TYPES.AJAX_END,
		payload: { ajaxRequestId }
	};
};

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		case AJAX_ACTION_TYPES.AJAX_START: {
			const { ajaxRequestId } = payload;
			const { ajaxRequests } = state;
			const ajaxRequestsCopy = {...ajaxRequests};
			ajaxRequestsCopy[ajaxRequestId] = true;
			return {
				...state,
				ajaxRequests: ajaxRequestsCopy
			};
		}
		case AJAX_ACTION_TYPES.AJAX_END: {
			const { ajaxRequestId } = payload;
			const { ajaxRequests } = state;
			const ajaxRequestsCopy = {...ajaxRequests};
			delete ajaxRequestsCopy[ajaxRequestId];
			return {
				...state,
				ajaxRequests: ajaxRequestsCopy
			};
		}
		default:
			console.log('action type not found: ', type);
			return state;
	}
};
